import React from 'react';
import './Sections.scss';

function Section4() {
  return (
    <section className="sections sections-section4">
      <h2 className="sections-title">Broadening the Search</h2>
      <p className="sections-copy">
        As buyers are feeling the crunch to find a home, many are looking farther afield. From 2018
        to 2021, homebuyers moved a median distance of 15 miles. This year, the number jumped to 50
        miles—another all-time high. Many buyers in this climate may need to look to smaller towns
        or an area beyond the suburbs to find a home they can afford. Or they may have to endure
        longer commutes for the opportunity to own instead of rent. Others, particularly after the
        changes wrought by the COVID-19 pandemic, may have the luxury of working from home or fewer
        days traveling into the office, giving them increased flexibility. Lautz notes that people
        are moving farther away because of affordability constraints, but “they also want to be
        close to friends and family, and the quality of life may be better. And so they're choosing
        small towns and outer suburbs because they have to, but also because they want to.”
      </p>
      <p className="sections-copy">
        These days it’s also easier to look for homes outside of your local towns and neighborhoods.
        NAR found that 96% of buyers used online search tools. But even if you find attractive
        options, finding time to look at several houses that are dozens of miles away can be a
        challenge. So while buyers looked at a median of nine homes, four of those nine were
        online-only viewings, on average. For one in ten buyers over the past year, looking at the
        home online was enough to purchase the house sight unseen. Naturally, having a real estate
        professional who can be physically present at the home is more important than ever,
        particularly if the house is a “fixer-upper.” That way, the only surprise is the good kind:
        finding a great house for an affordable price.
      </p>
    </section>
  );
}

export default Section4;
